import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "search-result-details-pane iodine-no-scroll-y full-height text-center flex column" }

import { computed } from 'vue';
import SearchResultDetailsTitle from 'components/search/SearchResultDetailsTitle.vue';
import SearchResultDetailsContent from 'components/search/SearchResultDetailsContent.vue';
import ProcedureTableToolbar from 'components/search/procedure/ProcedureTableToolbar.vue';
import { useSearchStore } from 'stores/search-store';
import { useHistoryStore } from 'stores/history-store';
import { SearchViewRecord } from 'src/services/searchService';


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchResultDetailsPane',
  setup(__props) {

const searchStore = useSearchStore();
const history = useHistoryStore<SearchViewRecord>('index-history', (one: SearchViewRecord, two: SearchViewRecord) => {
  return one?.data_id == two?.data_id;
});

const onBackButtonClicked = () => {
  searchStore.getResultDetails(history.getPrev());
};

const onNextButtonClicked = () => {
  searchStore.getResultDetails(history.getNext());
};

const showToolbar = computed(() => {
  return !searchStore.getSelectedProcedureCode || searchStore.isTableModeSelected;
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(SearchResultDetailsTitle),
    _withDirectives(_createVNode(ProcedureTableToolbar, {
      "enable-sub-search": true,
      "enable-back-button": _unref(history).isPrevAvailable,
      "enable-next-button": _unref(history).isNextAvailable,
      onBackButtonClicked: _cache[0] || (_cache[0] = ($event: any) => (onBackButtonClicked())),
      onNextButtonClicked: _cache[1] || (_cache[1] = ($event: any) => (onNextButtonClicked()))
    }, null, 8, ["enable-back-button", "enable-next-button"]), [
      [_vShow, showToolbar.value]
    ]),
    _createVNode(SearchResultDetailsContent)
  ]))
}
}

})